export const COLORS = {
  PRIMARY: '#bb1ccc',
  PRIMARY_LIGHT: '#e6e6f5',
  PRIMARY_DARK: '#000080',
};

